
import Swal from 'sweetalert2';

import { DOCUMENT } from '@angular/common';
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    Renderer2,
    AfterViewInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/restaurent-management/config/config.service';
import { AuthService } from 'src/app/restaurent-management/core/service/auth.service';
import { RightSidebarService } from 'src/app/restaurent-management/core/service/rightsidebar.service';
import { environment } from 'src/environments/environment';
const document: any = window.document;
import { HttpClient } from '@angular/common/http';
import { AppService } from 'src/app/app.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetComponent } from '../../shared/bottom-sheet/bottom-sheet.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
    public config: any = {};
    isNavbarCollapsed = true;
    RoleId: any;
    amount: any = 100;
    data:any;
    RestaurantInfo:any=[];
    changePswdObj: any = {}
    invaliddata: any[];
    RoleName: any;
    UserName:any;
    FirstName: any;
    LastName: any;
    UserID:any;
    ExistingPassword:any;
    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2, public HttpClient: HttpClient,
        public elementRef: ElementRef,
        private dataService: RightSidebarService,
        private configService: ConfigService,
        private authService: AuthService,
        private router: Router,
        private appservice: AppService,
        private modalService: NgbModal,
        private bottomSheet: MatBottomSheet,
    ) {
     }


    notifications: any[] = [
        {
            userImg: 'assets/images/user/user1.jpg',
            userName: 'Sarah Smith',
            time: '14 mins ago',
            message: 'Please check your mail',
        },
        {
            userImg: 'assets/images/user/user2.jpg',
            userName: 'Airi Satou',
            time: '22 mins ago',
            message: 'Work Completed !!!',
        },
        {
            userImg: 'assets/images/user/user3.jpg',
            userName: 'John Doe',
            time: '3 hours ago',
            message: 'kindly help me for code.',
        },
        {
            userImg: 'assets/images/user/user4.jpg',
            userName: 'Ashton Cox',
            time: '5 hours ago',
            message: 'Lets break for lunch...',
        },
        {
            userImg: 'assets/images/user/user5.jpg',
            userName: 'Sarah Smith',
            time: '14 mins ago',
            message: 'Please check your mail',
        },
        {
            userImg: 'assets/images/user/user6.jpg',
            userName: 'Airi Satou',
            time: '22 mins ago',
            message: 'Work Completed !!!',
        },
        {
            userImg: 'assets/images/user/user7.jpg',
            userName: 'John Doe',
            time: '3 hours ago',
            message: 'kindly help me for code.',
        },
    ];
    ngOnInit() {
        
        this.RoleId = parseInt(JSON.parse(localStorage.getItem('UserDetails')).RoleID);
        this.UserName =  JSON.parse(localStorage.getItem('UserDetails')).UserName
        this.UserID=  parseInt(JSON.parse(localStorage.getItem('UserDetails')).UserID);
        this.FirstName=  JSON.parse(localStorage.getItem('UserDetails')).FirstName;
        this.LastName =  JSON.parse(localStorage.getItem('UserDetails')).Lastname;
        this.ExistingPassword =  JSON.parse(localStorage.getItem('UserDetails')).PassWord;
    }

    ngAfterViewInit() {
        // set theme on startup
        if (localStorage.getItem('theme')) {
            this.renderer.removeClass(this.document.body, this.config.layout.variant);
            this.renderer.addClass(this.document.body, localStorage.getItem('theme'));
        } else {
            this.renderer.addClass(this.document.body, this.config.layout.variant);
        }

        if (localStorage.getItem('menuOption')) {
            this.renderer.addClass(
                this.document.body,
                localStorage.getItem('menuOption')
            );
        } else {
            this.renderer.addClass(
                this.document.body,
                'menu_' + this.config.layout.sidebar.backgroundColor
            );
        }

        if (localStorage.getItem('choose_logoheader')) {
            this.renderer.addClass(
                this.document.body,
                localStorage.getItem('choose_logoheader')
            );
        } else {
            this.renderer.addClass(
                this.document.body,
                'logo-' + this.config.layout.logo_bg_color
            );
        }

        if (localStorage.getItem('sidebar_status')) {
            if (localStorage.getItem('sidebar_status') === 'close') {
                this.renderer.addClass(this.document.body, 'side-closed');
                this.renderer.addClass(this.document.body, 'submenu-closed');
            } else {
                this.renderer.removeClass(this.document.body, 'side-closed');
                this.renderer.removeClass(this.document.body, 'submenu-closed');
            }
        } else {
            if (this.config.layout.sidebar.collapsed === true) {
                this.renderer.addClass(this.document.body, 'side-closed');
                this.renderer.addClass(this.document.body, 'submenu-closed');
            }
        }
    }
    callFullscreen() {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement &&
            !document.msFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }
    mobileMenuSidebarOpen(event: any, className: string) {
        const hasClass = event.target.classList.contains(className);
        if (hasClass) {
            this.renderer.removeClass(this.document.body, className);
        } else {
            this.renderer.addClass(this.document.body, className);
        }
    }
    callSidemenuCollapse() {
        const hasClass = this.document.body.classList.contains('side-closed');
        if (hasClass) {
            this.renderer.removeClass(this.document.body, 'side-closed');
            this.renderer.removeClass(this.document.body, 'submenu-closed');
        } else {
            this.renderer.addClass(this.document.body, 'side-closed');
            this.renderer.addClass(this.document.body, 'submenu-closed');
        }
    }
    public toggleRightSidebar(): void {
        this.dataService.changeMsg(
            (this.dataService.currentStatus._isScalar = !this.dataService
                .currentStatus._isScalar)
        );
    }

    changePassword(content) {
        this.modalService.open(content, { size: 'lg', backdrop: 'static' });
    }


    submitChange(changePasswordForm) {
        if (changePasswordForm.invalid) {
            const invalid = [];
            let controls = [];
            controls = changePasswordForm.controls;
            for (const name in controls) {
                if (controls[name].invalid) {
                    invalid.push(name);
                }
            }
            this.invaliddata = invalid;

           // this.appservice.InformationAlert('', 'warning', 'Warning', ' * Indicates Mandatory fields');
        }

        else {

            if (this.changePswdObj.NewPassword != this.changePswdObj.ConfirmPassword) {
               
                this.appservice.InformationAlert('', 'warning', 'Warning', 'New Password and Confirm Password does not match, It should be same');
                this.changePswdObj.ConfirmPassword = '';
                return;
            }
            else if(this.changePswdObj.OldPassword!=this.ExistingPassword){
                this.appservice.InformationAlert('', 'warning', 'Warning', 'Entered Current Password is wrong!');
                this.changePswdObj.OldPassword = '';
                return;
            }
            else{
                let params = {

                    intUserID: this.UserID, 
                    Password: this.changePswdObj.NewPassword,
                }

                console.log("params", params);

                let url = environment.apiUrl + 'changePasswordAuthenticateUser';

                this.HttpClient.post(url, null, { params: params }).toPromise().then(Response => {
                        
                    if (Response == "updated Successfully") {
                        this.appservice.InformationAlert('', 'success', 'Confirmation', 'Password Updated Successfully!');
                        this.changePswdObj = {};
                        this.modalService.dismissAll();
                    } else {
                        this.appservice.InformationAlert('', 'error', 'Error', 'Something Went Worng!, please try again lates');
                    }
                });
            }

             
        }
    }

    closeBtnModal(){
        this.modalService.dismissAll();
        this.changePswdObj = {};
    }
    HeaderHideInPOS() {
        return true;
    }

    logout() {
        this.appservice.InformationAlert('', 'success', 'Confirmation', 'Logged Out successfully!');
        localStorage.clear();
        localStorage.setItem('STATE', 'false');  
        this.router.navigate(['/authentication/signin']);

    }
}
